import React from 'react';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

const NoConnectionEmptyState: React.FC = () => {
  return (
    <Alert color="info" data-testid="wearables-dashboard-no-connection">
      <div>No active wearable connection</div>
      <Link to="/wearables">Go to integrations</Link>
    </Alert>
  );
};

export default NoConnectionEmptyState;
